export default "__VITE_ASSET__Bz2qQe5i__"